import Fetch from "../script/Fetch";
import { Incasso } from "orser-model/Incasso";
import { Tempistiche } from "orser-model/Tempistiche";
import { PiattoBi } from "orser-model/PiattoBi";
import { PiattoBiInformazioni } from "orser-model/PiattoBiInformazioni";
import { StaffBi } from "orser-model/StaffBi";
import { PeriodMetrics } from "orser-model/PeriodMetrics";

export class BusinessIntelligenceService {
    async getIncasso(ristoranteId: string, startDate: Date, endDate: Date) {
        console.log("Chiamata getIncasso iniziata");
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/incasso/totale?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return Incasso.fromJson(jsonObject);

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getTempistiche(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/tempistiche/totale?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return Tempistiche.fromJson(jsonObject);

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getPiatti(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/piatto/totale?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return PiattoBi.fromJson(jsonObject);

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getInformazioniPiatto(ristoranteId: string, startDate: Date, endDate: Date, nomePiatto: string) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                nomePiatto
            });

            const response = await Fetch.doFetch(`/businessintelligence/piatto/informazioni?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return PiattoBiInformazioni.fromJson(jsonObject);

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getStaff(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/staff/totale?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return StaffBi.fromJson(jsonObject);

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getProfitAndLoss(
        ristoranteId: string,
        startDate: Date,
        endDate: Date,
        periodType: string = 'mese'
    ) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString(),
                periodType,
            });
            const response = await Fetch.doFetch(`/businessintelligence/profitandloss/totale?${queryParams.toString()}`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const jsonObject = await response.json();
            return jsonObject;
        } catch (error: any) {
            console.log(error);
            throw new Error('Errore durante il recupero dei dati BI.');
        }
    }
}